import { useEffect } from "react";

export function useUpdateSpecDetails({
  specDetails,
  specCategoryId,
  specCategoryDetails,
  setFieldValue,
}) {
  useEffect(() => {
    const filteredSpecDetails = specDetails.filter(
      spec => !spec.id || spec.specCategoryId === specCategoryId
    );
    const newSpecCategoryDetails = specCategoryDetails.filter(
      spec => !filteredSpecDetails.some(newSpec => newSpec.id === spec.id)
    );

    const newSpecDetails = [
      ...filteredSpecDetails,
      ...newSpecCategoryDetails.map(spec => ({ ...spec, title: spec.name })),
    ];

    if (newSpecDetails.length !== specDetails.length)
      setFieldValue("specDetails", newSpecDetails);
  }, [specDetails, specCategoryId, specCategoryDetails, setFieldValue]);
}
